// Survey User Info - English
export default {
  balance: {
    available: "Available Balance",
    accountAssets: "Total Account Assets Preview (USDT)",
  },
  basicInfo: {
    title: "Basic Information",
    expandAll: "Expand All",
    collapseAll: "Collapse All",
  },
  character: {
    addCharacter: "Add Character",
    viewDetails: "View Details",
    syncFailed: "Character info sync failed",
  },
  fields: {
    name: "[Name]",
    userId: "[User ID]",
    username: "[Username]",
    nationality: "[Nationality]",
    idNumber: "[ID Number]",
    homePlace: "[Home Place]",
    sex: "[Gender]",
    phone: "[Phone]",
    email: "[Email]",
    registerTime: "[Register Time]",
    relatedCase: "[Related Case]",
    note: "[Note]",
    deviceId: "[Device ID]",
    firstUseTime: "[First Use Time]",
    analysisId: "[Analysis ID]",
    platform: "[Platform]",
    bindPhoneTime: "[Bind Phone Time]",
    paymentInfo: "[Payment Info]",
    walletAddress: "[Wallet Address]",
    usedAddress: "[Used Address]",
    watchedAddress: "[Watched Address]",
    walletAccount: "[Wallet Account]",
  },
  common: {
    none: "--",
    yes: "Yes",
    no: "No",
    noBank: "No related bank found",
    wechat: "WeChat",
    alipay: "Alipay",
    moreData: "records, load more",
    collapse: "Collapse",
  },
};
